import { Tag } from 'antd'
import React from 'react'
import KrwPrice from '../../PositionColumns/KrwPrice'
import PnlPrice from '../../PositionColumns/PnlPrice'
import UserTag from '../../UserTag'
import WalletTag from '../../WalletTag'
import Column_walletlist_action from './column_walletlist_action'
import { TagWrap } from './styles'

export const column_walletlist_page = (mutate, usermodal) => {
	return [
		{
			title: '그룹',
			dataIndex: 'referral_code',
			key: 'referral_code',
			align: 'center',
		},
		{
			title: '회원',
			dataIndex: 'user_id',
			key: 'user_id',
			align: 'center',
			render: (text, record) => (
				<UserTag
					userid={text}
					email={record?.email}
					nickname={record?.fullname || record?.nickname}
					level={record?.level}
					phone={record?.phone}
					onClick={() => {
						usermodal(text)
					}}
				/>
			),
		},
		{
			title: '아이디',
			dataIndex: 'loginid',
			key: 'loginid',
			align: 'center',
		},
		{
			title: '이메일',
			dataIndex: 'email',
			key: 'email',
			align: 'center',
		},
		{
			title: '계좌번호',
			dataIndex: 'id',
			key: 'id',
			align: 'center',
			render: (text, record) => (
				<WalletTag walletid={record?.id} type={record?.wallet_type} />
			),
		},
		{
			title: '화폐',
			dataIndex: 'wallet_type',
			key: 'wallet_type',
			align: 'center',
			render: (text, record) => (
				<TagWrap>
					<Tag>{record?.wallet_symbol}</Tag>
				</TagWrap>
			),
		},
		{
			title: '잔액',
			dataIndex: 'balance',
			align: 'center',
			key: 'balance',
			render: (text, record) => (
				<>
					{record?.wallet_type == 9 ? (
						<PnlPrice
							price={text}
							dp={0}
							krw={true}
							style={{ color: 'black' }}
							plus={false}
						/>
					) : (
						<KrwPrice
							price={text}
							dp={record?.wallet_type == 9 ? 0 : undefined}
							krw={record?.wallet_type == 9 ? true : false}
						/>
					)}
				</>
			),
		},
		{
			title: '동결금',
			dataIndex: 'lockbalance',
			align: 'center',
			key: 'lockbalance',
			render: (text, record) => (
				<>
					{record?.wallet_type == 9 ? (
						<PnlPrice
							price={text}
							dp={0}
							krw={true}
							style={{ color: 'black' }}
							plus={false}
						/>
					) : (
						<KrwPrice
							price={text}
							dp={record?.wallet_type == 9 ? 0 : undefined}
							krw={record?.wallet_type == 9 ? true : false}
						/>
					)}
				</>
			),
		},
		{
			title: '관리',
			dataIndex: 'action',
			align: 'center',
			key: 'action',
			render: (text, record) => (
				<Column_walletlist_action record={record} mutate={mutate} />
			),
		},
	]
}
